import { Context } from '@nuxt/types';
import { getRefreshedToken } from '../utils';

export default async function(context: Context) {
  const { app } = context;

  if (
    // @ts-ignore For some reason it does not know about the token property https://github.com/nuxt-community/auth-module/issues/1338
    app.$auth.strategy.token.get() &&
    // @ts-ignore For some reason it does not know about the token property https://github.com/nuxt-community/auth-module/issues/1338
    app.$auth.strategy.token.status().expired()
  ) {
    // @ts-ignore For some reason it does not know about the refreshToken property https://github.com/nuxt-community/auth-module/issues/1338
    if (!app.$auth.strategy.refreshToken.get()) {
      await app.$auth.logout();
      return;
    }

    try {
      if (app.apolloProvider) {
        await getRefreshedToken(app.$auth, app.apolloProvider.defaultClient);
      }
    } catch (err) {
      await app.$auth.logout();
    }
  }
}
